export default {
  domain: REPLACE_DOMAIN,
  campaignId: REPLACEWITHCAMPAIGNID,
  campaignDates: REPLACEWITHCAMPAIGNDATES,
  campaignCountry: REPLACEWITHCAMPAIGNCOUNTRY,
  campaignCurrency: REPLACEWITHCAMPAIGNCURRENCY,
  campaignConsumerFields: REPLACEWITHCAMPAIGNCONSUMERFIELDS,
  campaignUniverse: REPLACEWITHCAMPAIGNUNIVERSE,
  campaignPrizes: REPLACEWITHCAMPAIGNPRIZES,
  submissionUri: REPLACEWITHSUBMISSIONURI,
  s2rpromo: REPLACE_S2R_PROMO,
  version: REPLACE_VERSION,
}
